export const getIsApk = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const v = params.get("isApk") || params.get("is_apk");
    if (v === "1") {
      sessionStorage.setItem("isApk", "1");
      return true;
    }
    if (v === "0") {
      sessionStorage.removeItem("isApk");
      return false;
    }
  } catch (e) {}
  try {
    const ua = navigator.userAgent || "";
    const isAndroid = /Android/i.test(ua);
    const isWebView = isAndroid && /(wv|; wv\)|Version\/\d+\.\d+.*Chrome\/)/i.test(ua);
    if (!isWebView) {
      sessionStorage.removeItem("isApk");
    }
  } catch (e) {}
  return sessionStorage.getItem("isApk") === "1";
};

export const isStandalone = () => {
  return (
    window.matchMedia("(display-mode: standalone)").matches ||
    (window.navigator as any).standalone ||
    document.referrer.includes("android-app://")
  );
};
